import { sanitizeFilterTree, type JobFilterTree } from "@domain/CRM/job";

const KEY_PREFIX = "rogo_scheduling_filter:";

/**
 * Persists the Scheduling backlog filter tree per user+browser. Scope key
 * mirrors the job-count store (`getImpersonatedEmail() ?? "self"`). Reads run
 * the raw JSON through `sanitizeFilterTree`, so a stale/renamed field can never
 * crash the page — the offending condition is dropped and the rest survives.
 */
export const schedulingFilterStore = {
	get(scopeKey: string): JobFilterTree | null {
		const raw = localStorage.getItem(KEY_PREFIX + scopeKey);
		if (raw === null) return null;
		try {
			return sanitizeFilterTree(JSON.parse(raw));
		} catch {
			return null;
		}
	},
	set(scopeKey: string, tree: JobFilterTree): void {
		localStorage.setItem(KEY_PREFIX + scopeKey, JSON.stringify(tree));
	},
};
